export default [
  {
    emoji_active: "ANGRY_ACTIVE",
    emoji_inactive: "ANGRY_INACTIVE",
    value: 1,
  },
  {
    emoji_active: "SAD_ACTIVE",
    emoji_inactive: "SAD_INACTIVE",
    value: 2,
  },
  {
    emoji_active: "OKAY_ACTIVE",
    emoji_inactive: "OKAY_INACTIVE",
    value: 3,
  },
  {
    emoji_active: "HAPPY_ACTIVE",
    emoji_inactive: "HAPPY_INACTIVE",
    value: 4,
  },
  {
    emoji_active: "LOVEDIT_ACTIVE",
    emoji_inactive: "LOVEDIT_INACTIVE",
    value: 5,
  },
]
